import { render, staticRenderFns } from "./data-box.vue?vue&type=template&id=0379aa3c&scoped=true"
import script from "./data-box.vue?vue&type=script&lang=ts"
export * from "./data-box.vue?vue&type=script&lang=ts"
import style0 from "./data-box.vue?vue&type=style&index=0&id=0379aa3c&prod&lang=less&scoped=true"
import style1 from "./data-box.vue?vue&type=style&index=1&id=0379aa3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379aa3c",
  null
  
)

export default component.exports